const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/loop/$loopId/visualizations/view/$viewId/timeline/preview/$visualizationId/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/(app)/org/$org/loop/$loopId/visualizations/view/$viewId/timeline/preview/$visualizationId')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  staticData: {
    hideChrome: true,
    hideSidebarNav: true
  }
});